module.exports = __webpack_public_path__ + "static/media/TCO_DE.57ab9fae.png";


//////////////////
// WEBPACK FOOTER
// ./src/tco/assets/TCO_DE.png
// module id = 1507
// module chunks = 0